// DEROS: packs the showcase gallery the way the deros.gr reference does.
//
// Flatsome's masonry places each photo, in order, into whichever column is
// currently the shortest, so the eye reads left to right and the columns end
// ragged. CSS multi-column (the no-JavaScript layout in deros-showcase.css)
// flows photos top to bottom per column instead, which put the second photo
// under the first rather than beside it. This module rebuilds the reference
// behaviour: on desktop (3 columns) and tablet (2 columns) it moves the
// figures into column wrappers; on phones it leaves the CSS grid alone.
//
// Every image carries width and height attributes, so a column's height is
// known before the pictures load and the placement does not shift afterwards.
// The figures are moved, never cloned, so the lightbox module's slide list,
// captured in original DOM order before this runs, stays valid.

const GALLERY = ".deros-showcase__gallery";
const PACKED = "deros-showcase__gallery--packed";

for (const gallery of document.querySelectorAll(GALLERY)) {
  const figures = Array.from(gallery.children);
  let columns = [];
  let current = -1;

  const columnCount = () => (window.innerWidth >= 1000 ? 3 : window.innerWidth >= 700 ? 2 : 0);

  function unpack() {
    for (const figure of figures) gallery.appendChild(figure);
    for (const column of columns) column.remove();
    columns = [];
    gallery.classList.remove(PACKED);
  }

  function pack(count) {
    unpack();
    // Detach the figures before the columns exist: as direct children of the
    // flex container they would compete with the empty columns for width,
    // squeeze them to zero, and every image would measure zero height while
    // being placed.
    for (const figure of figures) figure.remove();
    gallery.classList.add(PACKED);
    columns = Array.from({ length: count }, () => {
      const column = document.createElement("div");
      column.className = "deros-showcase__column";
      gallery.appendChild(column);
      return column;
    });
    for (const figure of figures) {
      let target = columns[0];
      for (const column of columns) {
        if (column.offsetHeight < target.offsetHeight) target = column;
      }
      target.appendChild(figure);
    }
  }

  function layout() {
    const count = columnCount();
    if (count === current) return;
    current = count;
    if (count === 0) unpack();
    else pack(count);
  }

  layout();

  let timer;
  window.addEventListener("resize", () => {
    clearTimeout(timer);
    timer = setTimeout(layout, 150);
  });
}
